import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { getUserDisplayName } from 'owa-session-store';
import loc from 'owa-localize';
import { archiveDisplayName } from './getArchiveDisplayName.locstring.json';
import type { MailboxInfo } from 'owa-client-types';

/**
 * Gets the display name for an archive folder root, either the service display name or a localized name
 * when the 'fp-archive-name' feature flag is enabled or when no service display name exists.
 *
 * @param serviceDisplayName - The display name returned from the service for the archive folder
 * @param mailboxInfo - The mailbox info for the archive folder
 * @param displayName - Optional display name to use
 * @returns The formatted archive display name
 */
export function getArchiveDisplayName(
    serviceDisplayName: string | null | undefined,
    mailboxInfo: MailboxInfo,
    displayName?: string
): string {
    const userDisplayNameOrEmail =
        displayName ?? getUserDisplayName(mailboxInfo) ?? mailboxInfo.mailboxSmtpAddress;

    // If there is no service display name or the flight is enabled, use the localized name
    if (!serviceDisplayName || isGlobalFeatureEnabled('fp-archive-name')) {
        return loc(archiveDisplayName, userDisplayNameOrEmail);
    }

    return serviceDisplayName;
}
